<template>
  <div class="n35-loki">
    <!-- 移动端loading -->
    <Loading v-if="isMobile && isLoading" />
    <!-- 主图 -->
    <CarMainBanner :is-mobile="isMobile"
      banner-name="n30-loki"
      :banner-url="imgUrlPrefix + mainBanner"
      :title="mainTitle"
      sub-title="循北纬之线，赴经典之约"
      font-color-type="dark"
      mobile-font-color="dark"
      @pageLoad="pageLoad"
    />

    <!-- 图文混排组件 -->
    <CarTxtInImgList :is-mobile="isMobile" :txt-img-list="carTxtInImgList" mobile-font-color="light" />

    <!-- 上下布局组件: 上文字+下图片 -->
    <CarUpTxtDownImg :is-mobile="isMobile" :txt-img-obj="carUpTxtDownImgObject" />

    <!-- 图文混排组件 2 -->
    <CarTxtInImgList :is-mobile="isMobile" :txt-img-list="carTxtInImgList2" />
    <!-- 纯图片展示组件 -->
    <!-- <CarImgShow :img-list="[ (isMobile ? mobileCarImgList[0] : carImgList[0]) ]" /> -->
    <!-- 轮播组件 -->
    <MobileBannerCarousel v-if="isMobile" :carousel-obj="mobileCarouselObj" />
    <CarBannerCarousel v-else :carousel-list="carBannerCarouselList" />

    <!-- 纯图片展示组件 -->
    <!-- <CarImgShow v-if="!isMobile || mobileCarImgList[1]" :img-list="[ (isMobile ? mobileCarImgList[1] : carImgList[1]) ]" /> -->

    <!-- 图文混排组件 3 -->
    <CarTxtInImgList :is-mobile="isMobile" :txt-img-list="carTxtInImgList3" />

    <!-- 轮播组件 -->
    <MobileBannerCarousel v-if="isMobile" :carousel-obj="mobileCarouselObj2" />
    <CarBannerCarousel v-else :carousel-list="carBannerCarouselList2" />

    <!-- 车辆系列展示组件-1行3列 -->
    <CarSeriesComponent :car-series-obj="carSeriesObj" />

    <!-- 用户社群共创组件-多行多列 -->
    <!-- <CarCommunityComponent :car-community-obj="carCommunityObj" /> -->

    <!-- 底部生活方式组件 -->
    <CarLifeComponent :bg-img="carLifeBg" />
  </div>
</template>

<script>
import { checkIsMobile } from '../utils/tools.js'
import Loading from '../components/Loading.vue'
import CarMainBanner from '../components/CarMainBanner.vue'
import CarTxtInImgList from '../components/CarTxtInImgList.vue'
import CarUpTxtDownImg from '../components/CarUpTxtDownImg.vue'
import CarBannerCarousel from '../components/CarBannerCarousel.vue'
// import CarImgShow from '../components/CarImgShow.vue'
import CarSeriesComponent from '../components/CarSeriesComponents.vue'
// import CarCommunityComponent from '../components/CarCommunityComponent.vue'
import CarLifeComponent from '../components/CarLifeComponent.vue'
import MobileBannerCarousel from '../components/MobileBannerCarousel.vue'
export default {
  components: {
    Loading,
    CarMainBanner,
    CarTxtInImgList,
    CarUpTxtDownImg,
    CarBannerCarousel,
    // CarImgShow,
    CarSeriesComponent,
    // CarCommunityComponent,
    CarLifeComponent,
    MobileBannerCarousel,
  },
  mounted() {
    this.checkDevice();
    window.addEventListener('resize', this.checkDevice);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkDevice);
  },
  computed: {
    mainBanner() {
      return this.isMobile ? 'm-N30LokiMain.jpg' : 'N30LokiMain.jpg'
    },
    carLifeBg() {
      return this.isMobile ? '/assets/images/m-n30-life-bg.jpg' : '/assets/images/n30-life-bg.jpg'
    },
    mainTitle() {
      return this.isMobile ? 'N30° 致敬<br>每一段<br>传奇征途' : 'N30° 致敬每一段传奇征途'
    },

    // 上下布局: 上文字+下图片数据
    carUpTxtDownImgObject() {
      return {
        title: this.isMobile ? '沿北纬30°传奇纬线前行<br>与山脉壮阔相遇<br>真正的远行，始于城市<br>却从不被城市所定义' : '沿北纬30°传奇纬线前行，与山脉壮阔相遇<br>真正的远行，始于城市，却从不被城市所定义',
        desc: this.isMobile ? 
          '以 N30°洛基山脉为灵感<br>承袭其雄浑稳重、横贯全域的风骨<br>打造全能均衡、全场景稳定通行的标准越野<br>城市承载生活，而 N30°洛基承载向往<br>驶出城市边界，沿北纬 30°传奇纬线前行<br>与山脉壮阔相遇' : '以 N30°洛基山脉为灵感，承袭其雄浑稳重、横贯全域的风骨，打造全能均衡、全场景稳定通行的标准越野<br>城市承载生活，而 N30°洛基承载向往。驶出城市边界，沿北纬 30°传奇纬线前行，与山脉壮阔相遇',
        imgList: [this.imgUrlPrefix + 'sec2_1.jpg'],
        mobileImg: this.imgUrlPrefix + 'm-sec2_1.jpg',
      }
    },

    // 图文混排数据 2
    carTxtInImgList2() {
      return [
        {
          tag: '',
          title: this.isMobile ? 'DIALECTIC<br>推演' : 'DIALECTIC 推演',
          desc: '传承212六十余年硬派越野基因<br>以现代工艺重写经典 传递“永恒经典<br>匠心传承”的核心理念',
          img: this.imgUrlPrefix + 'sec3_1.jpg',
          mobileImg: this.imgUrlPrefix + 'm-sec3_1.jpg',
          txtLayout: 'center-top',
        },
        {
          tag: '',
          title: '经典硬派<br>姿态比例设计',
          desc: '标志性方盒车身，勾勒硬派经典轮廓<br>方正前后保造型搭配机械纹理<br>尽显硬派力量美学',
          img: this.imgUrlPrefix + 'sec3_2.jpg',
          mobileImg: this.imgUrlPrefix + 'm-sec3_2.jpg',
          txtLayout: 'right-center2',
        },
        {
          tag: '',
          title: '复古的圆灯设计',
          desc: this.isMobile ? 
            '经典圆灯<br>是向212和威利斯时代<br>最深情的回望<br>不是复刻，是致敬' : '经典圆灯，是向212和威利斯时代最深情的回望<br>不是复刻，是致敬。',
          img: this.imgUrlPrefix + 'sec3_3.jpg',
          mobileImg: this.imgUrlPrefix + 'm-sec3_3.jpg',
          txtLayout: 'left-top2',
        },
        {
          tag: '',
          title: '机械感力量美学',
          desc: '突出的轮眉、外露的门铰链、结实的侧踏板<br>不遮掩，不修饰<br>纯粹的功能主义设计',
          img: this.imgUrlPrefix + 'sec3_4.jpg',
          mobileImg: this.imgUrlPrefix + 'm-sec3_4.jpg',
          txtLayout: 'left-top3',
        },
        {
          tag: '',
          title: '',
          desc: '',
          img: this.imgUrlPrefix + 'sec3_5.jpg',
          mobileImg: this.imgUrlPrefix + 'm-sec3_5.jpg',
          txtLayout: 'none',
        },
        // 0424调整1个模块
        {
          tag: '',
          title: '深度定制体系',
          desc: '专属定制深橄榄绿，莱具军事与复古气质<br>搭配悬浮式银色车顶，层次分明，格调奢华',
          img: this.imgUrlPrefix + 'sec5_1.jpg',
          mobileImg: this.imgUrlPrefix + 'm-sec5_1.jpg',
          color: 'light',
          txtLayout: 'left-top',
        }

      ]
    },

  },
  data() {
    const imgUrlPrefix = '/assets/images/n30Loki/'
    return {
      isLoading: true,
      isMobile: false,
      imgUrlPrefix, // 图片地址前缀
      // 图文混排数据
      carTxtInImgList: [
        {
          tag: '',
          title: 'N30°ROCKY 洛基',
          desc: 'CHAPTERI',
          img: imgUrlPrefix + 'sec1_1.jpg',
          mobileImg: imgUrlPrefix + 'm-sec1_1.jpg',
          txtLayout: 'center-top2',
        }
      ],
      
      // 轮播数据
      carBannerCarouselList: [
        {
          img: imgUrlPrefix + 'sec4_1.jpg',
          title: '专属橄榄绿金属漆',
          desc: '融合哑光与金属质感，在不同光线下呈现细腻层次变化',
        },
        {
          img: imgUrlPrefix + 'sec4_2.jpg',
          title: '金属备胎架',
          desc: '内嵌 METTA 金属标识，以精密工艺呈现硬朗工业美学',
        },
        {
          img: imgUrlPrefix + 'sec4_3.jpg',
          title: '复古格栅护罩 + 圆形灯',
          desc: '既是穿越时的可靠光源，也是向经典硬派美学致敬的细节符号',
        },
        {
          img: imgUrlPrefix + 'sec4_4.jpg',
          title: '全地形轮胎 + 复古钢圈',
          desc: 'BFGoodrich 全地形轮胎搭配复古钢制轮毂，胎纹粗犷适配全路况穿越',
        },
      ],
      
      mobileCarImgList: [imgUrlPrefix + 'm-sec5_1.jpg'],
      // 轮播数据2
      carBannerCarouselList2: [
        {
          img: imgUrlPrefix + 'sec6_1.jpg',
          title: '座舱整体布局',
          desc: '复古撞色座舱设计，深绿、米白与棕红三色搭配<br>真皮、麂皮与木纹材质交相呼应',
        },
        {
          img: imgUrlPrefix + 'sec6_2.jpg',
          title: '车门内饰板',
          desc: '麂皮与真皮拼接的内饰板搭配金属质感按键与木纹饰件<br>兼顾复古氛围与现代触感',
        },
        {
          img: imgUrlPrefix + 'sec6_3.jpg',
          title: '方向盘',
          desc: '双色真皮包裹方向盘，深绿与棕红撞色搭配，复刻复古硬派座舱的经典配色',
        },
        {
          img: imgUrlPrefix + 'sec6_4.jpg',
          title: '座椅',
          desc: '真皮座椅包覆搭配 212 的刺绣标识，让每一次落座都能感受到经典硬派的温度',
        },
      ],
      // 车辆系列数据
      carSeriesObj: {
        logo: imgUrlPrefix + 'series-logo.png',
        desc: '以「高端定制」为核，共创专属格调',
        title: 'CLASSIC N30° 系列',
        series: 'CLASSIC',
        carList: [
          { img: imgUrlPrefix + 'sec7_1.png', name: 'N30° 环球', link: 'N30Cross'},
          { img: imgUrlPrefix + 'sec7_2.png', name: 'N30° 洛基', link: ''},
          { img: imgUrlPrefix + 'sec7_3.png', name: 'N30° 雅丹', link: 'N30ThreeDoors'},
        ]
      },
      // 用户社群共创数据
      carCommunityObj: {
        title: 'N30°用户社群共创',
        desc: 'N30°家族的模块化设计架构，天生为多元探索而生<br>它既承载了标准化量产的通用实力，量身打造专属越<br>野解决方案，陪你奔赴每一种远方。',
        imgList: [
          imgUrlPrefix + 'sec8_1.png', imgUrlPrefix + 'sec8_2.png', imgUrlPrefix + 'sec8_3.png', imgUrlPrefix + 'sec8_4.png',
          imgUrlPrefix + 'sec8_5.png', imgUrlPrefix + 'sec8_6.png', imgUrlPrefix + 'sec8_7.png', imgUrlPrefix + 'sec8_8.png',
          imgUrlPrefix + 'sec8_9.png', imgUrlPrefix + 'sec8_10.png', imgUrlPrefix + 'sec8_11.png', imgUrlPrefix + 'sec8_12.png',
        ]
      },
      // 图文混排数据 3
      carTxtInImgList3: [
        {
          tag: '',
          title: '奢感工艺的永恒魅力',
          desc: '皮革金属碰撞<br>演绎腕表级轻奢精密质感<br>橙棕饰条点睛<br>让硬派越野,从荒野驶向全球潮流之巅',
          img: imgUrlPrefix + 'sec5_2.jpg',
          mobileImg: imgUrlPrefix + 'm-sec5_2.jpg',
          txtLayout: 'none',
        },
      ],
      // 移动端轮播数据
      mobileCarouselObj: {
        title: '品质细节',
        bgColor: '#fff',
        list: [
          {
            img: imgUrlPrefix + 'sec4_1.jpg', name: '专属橄榄绿金属漆', desc: '融合哑光与金属质感，在不同光线下呈<br>现细腻层次变化',
          },
          {
            img: imgUrlPrefix + 'sec4_2.jpg', name: '金属备胎架', desc: '内嵌 METTA 金属标识，以精密工艺呈<br>现硬朗工业美学',
          },
          {
            img: imgUrlPrefix + 'sec4_3.jpg', name: '复古格栅护罩 + 圆形灯', desc: '既是穿越时的可靠光源，也是向经典硬<br>派美学致敬的细节符号',
          },
          {
            img: imgUrlPrefix + 'sec4_4.jpg', name: '全地形轮胎 + 复古钢圈', desc: 'BFGoodrich 全地形轮胎搭配复古钢制<br>轮毂，胎纹粗犷适配全路况穿越',
          },
        ]
      },

      // 移动端轮播数据 2
      mobileCarouselObj2: {
        title: '轻奢工艺',
        bgColor: '#fff',
        list: [
          {
            img: imgUrlPrefix + 'sec6_1.jpg', name: '座舱整体布局', desc: '复古撞色座舱设计，深绿、米白与棕红三色搭配，真皮、<br>麂皮与木纹材质交相呼应',
          },
          {
            img: imgUrlPrefix + 'sec6_2.jpg', name: '座椅', desc: '真皮座椅包覆搭配 212 的刺绣标识，让每一次落座都能感<br>受到经典硬派的温度',
          },
          {
            img: imgUrlPrefix + 'sec6_3.jpg', name: '车门内饰板', desc: '麂皮与真皮拼接的内饰板搭配金属质感按键与木纹饰件，<br>兼顾复古氛围与现代触感',
          },
          {
            img: imgUrlPrefix + 'sec6_4.jpg', name: '方向盘', desc: '双色真皮包裹方向盘，深绿与棕红撞色搭配，复刻复古硬<br>派座舱的经典配色',
          },
        ]
      },
    }
  },
  methods: {
    checkDevice() {
      this.isMobile = checkIsMobile()
    },
    pageLoad() {
      this.isLoading = false
    }
  },
  
}
</script>

<style lang="less" scoped>
.n35-loki {
  font-weight: @fw2;
  font-family: 'TsangerYunHei', sans-serif;
}
</style>